import type { GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';
export type RallyChoice = { id: string; label: string; correct: boolean; mediaUrl?: string };
export type RallyQuestion = { id: string; prompt: string; mediaUrl?: string; choices: RallyChoice[] };
export type RallyConfig = { id: string; questions: RallyQuestion[] };
export function draftToRallyConfig(source: Pick<GameDraft | PublishedGame, 'id' | 'questions' | 'maxLevels'>): RallyConfig {
  return { id: source.id, questions: Array.from({ length: source.maxLevels }, (_, i) => {
    const q = source.questions.find(q => q.levels[0] === i + 1);
    if (!q) throw new Error(`${i + 1}. Şerit Rallisi sorusu bulunamadı.`);
    return { id: q.id, prompt: q.prompt, mediaUrl: q.media?.url,
      choices: q.choices.map(c => ({ id: c.id, label: c.text, correct: c.isCorrect, mediaUrl: c.media?.url })) };
  }) };
}
